(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labreeze-brala-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="LabreezeBrala-"]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const blogLink = root.querySelector('.lbb-blog-section .lbb-heading > a');
      if (blogLink) blogLink.href = `${window.Shopify?.routes?.root || '/'}blogs/news`;
      const reveal = root.querySelectorAll('[data-lbb-reveal]');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: .12 });
      reveal.forEach((item) => observer.observe(item));

      root.querySelectorAll('[data-lbb-slider]').forEach((slider) => {
        const slides = Array.from(slider.querySelectorAll('.lbb-hero-slide'));
        const dots = Array.from(slider.querySelectorAll('[data-lbb-dot]'));
        if (slides.length < 2) return;
        let active = 0;
        let timer;
        const show = (next) => {
          active = (next + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const selected = index === active;
            slide.classList.toggle('is-active', selected);
            slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
            slide.tabIndex = selected ? 0 : -1;
          });
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
        };
        const play = () => {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          clearInterval(timer);
          timer = setInterval(() => show(active + 1), 4300);
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); play(); }));
        slider.addEventListener('mouseenter', () => clearInterval(timer));
        slider.addEventListener('mouseleave', play);
        slider.addEventListener('focusin', () => clearInterval(timer));
        slider.addEventListener('focusout', play);
        play();
      });

      root.querySelectorAll('.lbb-event-products-wrap').forEach((wrap) => {
        const rail = wrap.querySelector('[data-lbb-product-rail]');
        if (!rail) return;
        let loading = false;
        let loadedAll = false;
        let collectionPage = 1;
        const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(Number(value || 0));
        const loadMoreProducts = async () => {
          if (loading || loadedAll || !rail.dataset.collectionHandle) return;
          loading = true;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}collections/${rail.dataset.collectionHandle}/products.json?limit=250&page=${collectionPage}`);
            if (!response.ok) throw new Error('Collection unavailable');
            const payload = await response.json();
            const existing = new Set(Array.from(rail.querySelectorAll('[data-product-handle]')).map((card) => card.dataset.productHandle));
            rail.querySelectorAll('.lbb-event-product').forEach((card) => { const link = card.querySelector('.lbb-event-product__title'); if (link) card.dataset.productHandle = link.getAttribute('href')?.split('/products/')[1]?.split('?')[0] || ''; });
            rail.querySelectorAll('[data-product-handle]').forEach((card) => existing.add(card.dataset.productHandle));
            const products = payload.products || [];
            products.forEach((product) => {
              if (existing.has(product.handle)) return;
              const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
              if (!variant) return;
              const card = document.createElement('article');
              card.className = 'lbb-event-product';
              card.dataset.productHandle = product.handle;
              const imageLink = document.createElement('a'); imageLink.className = 'lbb-event-product__image'; imageLink.href = `/products/${product.handle}`;
              if (product.images?.[0]?.src) { const image = document.createElement('img'); image.src = product.images[0].src; image.alt = product.title; image.loading = 'lazy'; image.width = 640; image.height = 640; imageLink.appendChild(image); }
              const title = document.createElement('a'); title.className = 'lbb-event-product__title'; title.href = `/products/${product.handle}`; title.textContent = product.title;
              const price = document.createElement('strong'); price.textContent = money(variant.price);
              const form = document.createElement('form'); form.className = 'lbb-event-product__form'; form.method = 'post'; form.action = '/cart/add';
              const input = document.createElement('input'); input.type = 'hidden'; input.name = 'id'; input.value = variant.id;
              const button = document.createElement('button'); button.type = 'submit'; button.disabled = !variant.available; button.textContent = variant.available ? 'Add to cart' : 'Sold out';
              form.append(input, button); card.append(imageLink, title, price, form); rail.appendChild(card);
            });
            collectionPage += 1;
            loadedAll = products.length < 250;
          } catch (error) {
            loadedAll = false;
          } finally { loading = false; }
        };
        const move = async (direction) => { if (direction > 0 && rail.scrollWidth <= rail.clientWidth * 2) await loadMoreProducts(); rail.scrollBy({ left: direction * Math.max(rail.clientWidth * .82, 260), behavior: 'smooth' }); };
        wrap.querySelector('[data-lbb-scroll-prev]')?.addEventListener('click', () => move(-1));
        wrap.querySelector('[data-lbb-scroll-next]')?.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', () => { if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - rail.clientWidth) loadMoreProducts(); }, { passive: true });
      });

      root.addEventListener('submit', async (event) => {
          const form = event.target.closest('.lbb-event-product__form');
          if (!form || !root.contains(form)) return;
          event.preventDefault();
          const button = form.querySelector('button');
          if (!button || button.disabled) return;
          const original = button.textContent;
          button.disabled = true;
          button.textContent = 'Adding…';
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
            if (!response.ok) throw new Error('Unable to add');
            button.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
          } catch (error) {
            button.textContent = 'Try again';
            button.disabled = false;
          }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labreeze-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="LabreezeScrollStory-"]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      document.documentElement.classList.add('lbs-scroll-page');
      const scenes = [...root.querySelectorAll('[data-lbs-scene]')];
      const progress = [...root.querySelectorAll('.lbs-progress a')];
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          const index = scenes.indexOf(entry.target);
          progress.forEach((link, itemIndex) => link.classList.toggle('is-active', itemIndex === index));
        });
      }, { threshold: .28 });
      scenes.forEach((scene) => observer.observe(scene));
      const rail = root.querySelector('[data-lbs-rail]');
      const move = (direction) => rail?.scrollBy({ left: direction * Math.min(650, rail.clientWidth * .85), behavior: 'smooth' });
      root.querySelector('[data-lbs-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-lbs-next]')?.addEventListener('click', () => move(1));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
